import { render, staticRenderFns } from "./CustomerImportPreflight.vue?vue&type=template&id=21b4af22&scoped=true"
import script from "./CustomerImportPreflight.vue?vue&type=script&lang=js"
export * from "./CustomerImportPreflight.vue?vue&type=script&lang=js"
import style0 from "./CustomerImportPreflight.vue?vue&type=style&index=0&id=21b4af22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b4af22",
  null
  
)

export default component.exports